import React from 'react';
import './Loader.css';

export default function Loader({ text = 'Loading' }) {
  return (
    <div className="loader-container">
      <div className="loader-content">
        {/* Logo Wrapper with Ripple Effects */}
        <div className="logo-wrapper">
          <div className="ripple"></div>
          <div className="ripple"></div>
          <div className="ripple"></div>
          
          {/* Main Logo */}
          <img 
            src="/images/sync_logo.png" 
            alt="Sync and Explore Logo" 
            className="loader-logo"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </div>

        {/* Elegant Loading Text with Animated Dots */}
        <div className="loading-text">
          {text}
          <span className="dot">.</span>
          <span className="dot">.</span>
          <span className="dot">.</span>
        </div>
      </div>
    </div>
  );
}
